export default __webpack_public_path__ + "static/media/elemento_1.79a027fb.svg";